import React, { useState, useEffect } from "react";
import { updateDb } from "../services/updateDb";

import { useNavigate, useSearchParams } from "react-router-dom";
import useAxiosFetch from "../common/useAxiosFetch";

import LoadPage from "../common/LoadPage";
import TwoFactorAuthModal from "./TwoFactorAuthModal";
import PasswordChangeModal from "./PasswordChangeModal";
import AlertMessage from "../common/AlertMessage";
import UserForm from "./UserForm";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";

const EditUserPage = () => {
  const { t } = useTranslation();
  const { currentOrg, currentProject, currentUser, showAlertMessage, alertMessage } = useAppContext();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get("userId");

  const { data, loading, refetch } = useAxiosFetch("/api/users/" + userId);
  const navigate = useNavigate();

  const [show2FAModal, setShow2FAModal] = useState(false); 
  const [showPwdModal, setShowPwdModal] = useState(false); 

  // Refetch data whenever userId changes
  // useEffect(() => {
  //   refetch();
  // }, [userId]);
  
  const handleSubmit = async (data) => {
    let userObj = {
      name: data.name,
      email: data.email,
      role: data.role,
      orgId: data.orgId || currentOrg.id,
      projectId: data.projectId || currentProject.id,
    };

    const res = await updateDb("/api/users/update/" + userId, userObj);

    if (res.success) {
      if(currentUser.user_id == userId) {
        showAlertMessage('warning', t('profile') + " " + t('updated'));

      }
      else {
        navigate("/users", { state: { message: t('user') + " " + t('updated'), type: "warning" } });
      }
    }
    else {
      showAlertMessage('error', res.error || 'Error updating user.');
    }
  };

  // Function to open the 2FA modal
  const handleOpen2FAModal = () => {
    setShow2FAModal(true);
  };

  // Function to close the 2FA modal
  const handleClose2FAModal = () => {
    setShow2FAModal(false);
  };


  const handleOpenPwdModal = () => {
    setShowPwdModal(true);
  };

  const handleClosePwdModal = () => {
    setShowPwdModal(false);
  };

  if (loading || !data.name)
    return <LoadPage />;

  return (
    <div id="content">
      <div id="content-title">{data.id === currentUser.user_id ? t('my_profile') : t('edit_user')}</div>

      <div className="content-bubble">
        <AlertMessage type={alertMessage.type} message={alertMessage.content} />

        {data.id === currentUser.user_id && (
          <TwoFactorAuthModal
            show={show2FAModal}
            handleClose={handleClose2FAModal}
            refetchUserData={refetch}
            twoFactorEnabledInitial={data.twoFactorEnabled}
          />
        )}

        {data.id === currentUser.user_id && (
          <PasswordChangeModal
            show={showPwdModal}
            handleClose={handleClosePwdModal}
          />
        )}

        <UserForm
          handleSubmit={handleSubmit}
          key={userId} // Add this line
          userData={data}
          text={data.id === currentUser.user_id ? t('update_profile') : t('edit_user')}
          handleOpen2FAModal={handleOpen2FAModal}
          handleOpenPwdModal={handleOpenPwdModal}
        />
      </div>
    </div>
  );
};

export default EditUserPage;
